/**
 * Video loading and placeholder management
 */

/**
 * Initialize video placeholder functionality
 * Simple approach: show custom placeholder for 3 seconds, then fade out
 */
export function initVideoPlaceholders() {
	// Find all custom placeholders
	const placeholders = document.querySelectorAll('[id^="video-placeholder"]');
	
	placeholders.forEach(placeholder => {
		// Add fade transition
		placeholder.style.transition = 'opacity 1s ease-out';
		
		// Fade out after 3 seconds
		setTimeout(() => {
			placeholder.style.opacity = '0';
			
			// Remove from DOM after fade completes
			setTimeout(() => {
				placeholder.remove();
			}, 1000);
		}, 3000);
	});
}